module.exports = __webpack_public_path__ + "static/img/剪3.c222250.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/剪3.png
// module id = Fstv
// module chunks = 2